var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jIndexFlows" }, [
    _c(
      "div",
      {
        staticClass: "studio-page-header",
        class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
        staticStyle: {
          "padding-bottom": "0 !important",
          "padding-top": "15px !important",
          height: "110px"
        }
      },
      [
        _c("div", { staticClass: "title-tab-experience-manager" }, [
          _vm._v("WORKFLOW MANAGER")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex m__t--42" }, [
          _c(
            "div",
            {
              staticClass: "tab-experience-manager m__r--35",
              class: {
                "tab-experience-manager-active": _vm.tabSelected === "flow"
              },
              on: {
                click: function($event) {
                  _vm.selectTab("flow")
                }
              }
            },
            [_vm._v("\n        FLOW\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-experience-manager m__r--35",
              class: {
                "tab-experience-manager-active": _vm.tabSelected === "flow_sla"
              },
              on: {
                click: function($event) {
                  _vm.selectTab("flow_sla")
                }
              }
            },
            [_vm._v("\n        FLOW SLA\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-experience-manager",
              class: {
                "tab-experience-manager-active": _vm.tabSelected === "rules"
              },
              on: {
                click: function($event) {
                  _vm.selectTab("rules")
                }
              }
            },
            [_vm._v("\n        RULES\n      ")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "studio-page-content" },
      [
        _vm.tabSelected === "flow" ? _c("jFlowIndex") : _vm._e(),
        _vm._v(" "),
        _vm.tabSelected === "flow_sla" ? _c("jFlowSLA") : _vm._e(),
        _vm._v(" "),
        _vm.tabSelected === "rules"
          ? _c(
              "div",
              [
                _c("j-rules", {
                  ref: "rules",
                  on: {
                    "row-click": _vm.rulesRowClick,
                    pagination: _vm.hideFloatingPrompt
                  }
                }),
                _vm._v(" "),
                _vm.rules
                  ? _c("jRulesFloatingPrompt", {
                      ref: "rulesFloating",
                      staticClass: "rulesfloating",
                      attrs: { rules: _vm.rules },
                      on: {
                        hideFloatingPrompt: _vm.hideFloatingPrompt,
                        deleteRules: _vm.deleteRules
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0)
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("div", { staticClass: "space-floating" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-270e3bd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270e3bd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/index.vue
// module id = null
// module chunks = 